import { render, staticRenderFns } from "./default_About.vue?vue&type=template&id=d1ffbb8e&"
import script from "./default_About.vue?vue&type=script&lang=js&"
export * from "./default_About.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports